var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"border":"","columns":_vm.columns,"data":_vm.data,"size":"small"},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('Poptip',{attrs:{"confirm":"","title":"确定要删除吗?"},on:{"on-ok":function($event){return _vm.remove(index)}}},[_c('Button',{attrs:{"type":"error","size":"small"}},[_vm._v("删除")])],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }